import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ icon = '📭', title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-14 text-center">
      <div className="mb-3 text-4xl" aria-hidden>
        {icon}
      </div>
      <p className="text-[17px] font-semibold text-ink">{title}</p>
      {description && <p className="mt-1.5 max-w-sm text-ink-secondary">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('animate-pulse rounded-lg bg-app', className)} />;
}

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div
      role="alert"
      className="flex flex-col items-start gap-2 rounded-[var(--radius-card)] bg-danger-soft p-5 text-danger"
    >
      <p className="font-medium">Gagal memuat data</p>
      <p className="text-sm">{message}</p>
      {onRetry && (
        <button onClick={onRetry} className="mt-1 text-sm font-medium underline">
          Coba lagi
        </button>
      )}
    </div>
  );
}

export function Banner({
  tone = 'danger',
  children,
}: {
  tone?: 'danger' | 'success' | 'info';
  children: ReactNode;
}) {
  const tones = {
    danger: 'bg-danger-soft text-danger',
    success: 'bg-success-soft text-success',
    info: 'bg-primary-soft text-primary',
  };
  return (
    <div role="alert" className={cn('rounded-[var(--radius-input)] px-4 py-3 text-sm', tones[tone])}>
      {children}
    </div>
  );
}
